import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Compass, Briefcase, Wallet, Users, UserCircle, Package } from 'lucide-react';

const BottomNavigation = () => {
  const location = useLocation();
  
  return (
    <nav className="improved-visiontech-bottom-nav">
      <div className="improved-visiontech-bottom-nav-background">
        <div className="improved-visiontech-bottom-nav-glow-left"></div>
        <div className="improved-visiontech-bottom-nav-glow-right"></div>
        <div className="improved-visiontech-bottom-nav-particles">
          <div className="improved-visiontech-bottom-nav-particle p1"></div>
          <div className="improved-visiontech-bottom-nav-particle p2"></div>
          <div className="improved-visiontech-bottom-nav-particle p3"></div>
        </div>
      </div>
      
      {[
        { to: '/home', icon: Compass, label: 'Explore', gradient: 'explore-gradient' },
        { to: '/packages', icon: Package, label: 'Packages', gradient: 'packages-gradient' },
        { to: '/order', icon: Briefcase, label: 'Portfolio', gradient: 'portfolio-gradient' },
        { to: '/proof', icon: Wallet, label: 'Finances', gradient: 'finances-gradient' },
        // { to: '/team', icon: Users, label: 'Team', gradient: 'team-gradient' },
        { to: '/me', icon: UserCircle, label: 'Profile', gradient: 'profile-gradient' }
      ].map(({ to, icon: Icon, label, gradient }) => {
        const isActive = location.pathname === to;
        return (
          <Link
            key={to}
            to={to}
            className={`improved-visiontech-bottom-nav-item ${isActive ? 'improved-visiontech-bottom-nav-active' : ''}`}
          >
            <div className={`improved-visiontech-bottom-nav-icon-container ${isActive ? 'improved-visiontech-bottom-nav-icon-active' : ''} ${gradient}`}>
              <Icon 
                size={isActive ? 22 : 20} 
                className="improved-visiontech-bottom-nav-icon"
                strokeWidth={isActive ? 2.5 : 2}
              />
              {isActive && <div className="improved-visiontech-bottom-nav-glow"></div>}
            </div>
            <span className="improved-visiontech-bottom-nav-label">{label}</span>
            {isActive && <div className="improved-visiontech-bottom-nav-indicator"></div>}
          </Link>
        );
      })}

      <style jsx>{`
        .improved-visiontech-bottom-nav {
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          height: 75px;
          background: linear-gradient(135deg, #1e293b, #0f172a);
          box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.15);
          border-radius: 20px 20px 0 0;
          padding: 0 10px 5px;
          z-index: 1000;
          border-top: 1px solid rgba(120, 113, 255, 0.1);
          overflow: hidden;
        }
        
        .improved-visiontech-bottom-nav-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          opacity: 0.7;
        }
        
        .improved-visiontech-bottom-nav-glow-left {
          position: absolute;
          width: 150px;
          height: 150px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(245, 185, 66, 0.15) 0%, transparent 70%);
          top: -100px;
          left: -50px;
          z-index: 0;
        }
        
        .improved-visiontech-bottom-nav-glow-right {
          position: absolute;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(121, 113, 234, 0.15) 0%, transparent 70%);
          bottom: -80px;
          right: -30px;
          z-index: 0;
        }
        
        .improved-visiontech-bottom-nav-particles {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          overflow: hidden;
          z-index: 0;
        }
        
        .improved-visiontech-bottom-nav-particle {
          position: absolute;
          border-radius: 50%;
          opacity: 0.1;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, transparent 70%);
          animation-timing-function: ease-in-out;
          animation-iteration-count: infinite;
          animation-direction: alternate;
        }
        
        .improved-visiontech-bottom-nav-particle.p1 {
          width: 20px;
          height: 20px;
          top: 20%;
          left: 30%;
          animation: float1 8s infinite;
        }
        
        .improved-visiontech-bottom-nav-particle.p2 {
          width: 15px;
          height: 15px;
          bottom: 30%;
          right: 20%;
          animation: float2 6s infinite;
        }
        
        .improved-visiontech-bottom-nav-particle.p3 {
          width: 10px;
          height: 10px;
          top: 50%;
          left: 70%;
          animation: float3 10s infinite;
        }
        
        @keyframes float1 {
          0% { transform: translateY(0) scale(1); }
          100% { transform: translateY(-10px) scale(1.1); }
        }
        
        @keyframes float2 {
          0% { transform: translateY(0) scale(1); }
          100% { transform: translateY(10px) scale(1.15); }
        }
        
        @keyframes float3 {
          0% { transform: translateX(0) scale(1); }
          100% { transform: translateX(15px) scale(1.1); }
        }

        .improved-visiontech-bottom-nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          height: 100%;
          text-decoration: none;
          color: #94a3b8;
          position: relative;
          transition: all 0.3s ease;
          padding: 8px 0;
          z-index: 1;
        }

        .improved-visiontech-bottom-nav-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 12px;
          margin-bottom: 4px;
          position: relative;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .improved-visiontech-bottom-nav-icon {
          z-index: 2;
          transition: all 0.3s ease;
        }

        .improved-visiontech-bottom-nav-icon-active {
          transform: translateY(-8px);
          color: white;
        }

        .improved-visiontech-bottom-nav-glow {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          filter: blur(8px);
          opacity: 0.7;
          z-index: 0;
        }

        .improved-visiontech-bottom-nav-active {
          color: #e2e8f0;
          font-weight: 500;
        }

        .improved-visiontech-bottom-nav-label {
          font-size: 12px;
          margin-top: 4px;
          font-weight: 500;
          transition: all 0.3s ease;
          opacity: 0.9;
        }

        .improved-visiontech-bottom-nav-active .improved-visiontech-bottom-nav-label {
          transform: translateY(-2px);
        }

        .improved-visiontech-bottom-nav-indicator {
          position: absolute;
          bottom: 0;
          width: 5px;
          height: 5px;
          background: #f5b942;
          border-radius: 50%;
          transition: all 0.3s ease;
          box-shadow: 0 0 8px #f5b942;
        }

        /* Gradient backgrounds for active icons */
        .explore-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #f5b942 0%, #c89b3c 100%);
          box-shadow: 0 5px 15px rgba(245, 185, 66, 0.3);
        }

        .packages-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #c89b3c 0%, #f5b942 100%);
          box-shadow: 0 5px 15px rgba(200, 155, 60, 0.3);
        }

        .portfolio-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #f5b942 20%, #d4af37 100%);
          box-shadow: 0 5px 15px rgba(212, 175, 55, 0.3);
        }

        .finances-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #d4af37 0%, #c89b3c 100%);
          box-shadow: 0 5px 15px rgba(212, 175, 55, 0.3);
        }

        .team-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #c89b3c 20%, #f5b942 100%);
          box-shadow: 0 5px 15px rgba(200, 155, 60, 0.3);
        }

        .profile-gradient.improved-visiontech-bottom-nav-icon-active {
          background: linear-gradient(135deg, #f5b942 0%, #d4af37 100%);
          box-shadow: 0 5px 15px rgba(245, 185, 66, 0.3);
        }

        /* Hover effects */
        .improved-visiontech-bottom-nav-item:hover .improved-visiontech-bottom-nav-icon-container:not(.improved-visiontech-bottom-nav-icon-active) {
          background: rgba(245, 185, 66, 0.1);
          transform: translateY(-2px);
        }

        .improved-visiontech-bottom-nav-item:hover .improved-visiontech-bottom-nav-icon:not(.improved-visiontech-bottom-nav-active) {
          color: #e2e8f0;
        }

        /* Responsive adjustments */
        @media (max-width: 480px) {
          .improved-visiontech-bottom-nav {
            height: 70px;
            padding-bottom: 8px;
          }

          .improved-visiontech-bottom-nav-icon-container {
            width: 38px;
            height: 38px;
          }

          .improved-visiontech-bottom-nav-label {
            font-size: 11px;
          }
        }

        /* Notch support for iPhone */
        @supports (padding-bottom: env(safe-area-inset-bottom)) {
          .improved-visiontech-bottom-nav {
            padding-bottom: calc(5px + env(safe-area-inset-bottom));
          }
        }
      `}</style>
    </nav>
  );
};

export default BottomNavigation;
